// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a2596cf0","447":"c6fa5f2a","455":"66c9ae80","602":"1077b8ab","967":"95f04c0c","977":"8267fac5"}[chunkId] + ".chunk.js";
};